// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteInvoice_root__C2a8E"};